<mat-card >
  <mat-card-header>
    <div mat-card-avatar><i class="fa fa-cog fa-2x"></i></div>
    <mat-card-title>Configuración de Sistemas de Pago</mat-card-title>
    <mat-card-subtitle>Administre sus pagos</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-full">
        <div class="hours">
          @for (item of paymentTypes; track $index) {
            <div class="payment-type">
              <div class="title">{{item.name}}</div>
              <div class="check" *ngIf="payments[item.key]"><i class="fa fa-check-circle"></i></div>
              <div class="check" *ngIf="loading">
                <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
              </div>
              <button class="button" mat-raised-button color=primary (click)="linkAccount(item.key)" *ngIf="!payments[item.key] && !loading">Enlazar Cuenta</button>
            </div>
          }
        </div>
      </div>

    </div>
  </mat-card-content>
</mat-card>
